import React from 'react';
import cx from 'classnames';
import { slide as Menu } from 'react-burger-menu';
import selectedPNG from './selected.png';
import SettingsActions from '../weather/settings_actions';
import SettingsStore from '../weather/settings_store';

export default class Sidebar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      settings: SettingsStore.getInitialState(),
    };
  }

  componentDidMount() {
    this.unsubscribe = SettingsStore.listen(this.onDataChange.bind(this));
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  onDataChange(data) {
    this.setState(data);
  }

  isOfferwallEnabled() {
    return this.state.settings.get('integration') === 'offerwall';
  }

  getActiveClass(key, value) {
    if (this.isOfferwallEnabled() && (key === 'format' || key === 'integration')) {
      return cx({ disabled: true });
    }
    const selected = (this.state.settings.get(key) === value);
    return cx({ selected });
  }

  getSectionClass() {
    let disabled = false;
    if (this.isOfferwallEnabled()) {
      disabled = true;
    }
    return cx({ disabled, setting: true });
  }

  render() {
    return (
      <Menu id="sidebar">
        <div className={this.getSectionClass()}>
          <h4>Survey Formats</h4>
          <ul>
            <li
              onClick={this.handleSettingChange.bind(this, 'format', 'basic')}
              className={this.getActiveClass('format', 'basic')}
            >
              Basic Surveys <img src={selectedPNG} alt="selected" />
            </li>
            <li
              onClick={this.handleSettingChange.bind(this, 'format', 'playful')}
              className={this.getActiveClass('format', 'playful')}
            >
              Playful Surveys <img src={selectedPNG} alt="selected" />
            </li>
            <li
              onClick={this.handleSettingChange.bind(this, 'format', 'third-party')}
              className={this.getActiveClass('format', 'third-party')}
            >
              Mediation Surveys<img src={selectedPNG} alt="selected" />
            </li>
          </ul>
        </div>
        <div className="setting">
          <h4>Integration Approach</h4>
          <ul>
            <li
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div style={{ flex: 1 }}>Offerwall <img src={selectedPNG} alt="selected" /></div>

              <div>
                <input
                  className="tgl tgl-light"
                  id="cb1"
                  type="checkbox"
                  onChange={this.handleOfferwallChange.bind(this)}
                />
                <label className="tgl-btn" htmlFor="cb1"></label>
              </div>
            </li>
          </ul>
        </div>
        <div className="setting">
          <h4>Weather Settings</h4>
          <ul>
            <li>Units
              <span
                onClick={this.handleSettingChange.bind(this, 'units', 'f')}
                className={this.getActiveClass('units', 'f')}
              >°F</span>
              <span
                onClick={this.handleSettingChange.bind(this, 'units', 'c')}
                className={this.getActiveClass('units', 'c')}
              >°C</span>
            </li>
          </ul>
        </div>
        <div>
          <h4>
              <i className="icon-logo pf-logo"></i>
          </h4>
          <ul>
            <li>
              <a id="about" className="menu-item" href="https://www.pollfish.com/terms/publisher" target="_blank">Publisher Terms and Conditions</a>
            </li>
            <li>
              <a id="about" className="menu-item" href="https://www.pollfish.com/company/about" target="_blank">About</a>
            </li>
          </ul>
        </div>
      </Menu>
    );
  }

  handleOfferwallChange(e) {
    const isChecked = e.target.checked;
    SettingsActions.set('showWeatherDetails', false);
    SettingsActions.set('integration', isChecked ? 'offerwall' : 'rewarded');
    SettingsActions.set('userNotEligible', false);
  }

  handleSettingChange(key, value) {
    if (this.isOfferwallEnabled()) {
      // click is disabled
      return false;
    }
    SettingsActions.set('showWeatherDetails', false);
    SettingsActions.set(key, value);
    SettingsActions.set('userNotEligible', false);
  }

}



// WEBPACK FOOTER //
// ./src/components/common/sidebar.js